import { render } from "./SliderForm.vue?vue&type=template&id=7ce8cb03&scoped=true"
import script from "./SliderForm.vue?vue&type=script&lang=js"
export * from "./SliderForm.vue?vue&type=script&lang=js"

import "./SliderForm.vue?vue&type=style&index=0&id=7ce8cb03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce8cb03"]])

export default __exports__